import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { v4 as uuidv4 } from 'uuid';
import { RootInjectorGuard } from './root-injector-guard';
import { PreferenceItem } from '../../../modules/forms/models/preferenceitem';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService extends RootInjectorGuard {
  private preferencesObject?: Preferences;
  private currentPreferences: { [key: string]: any; } = {};
  //private defaultPreferences: { [key: string]: any; } = { 'general.dateformat': 'dd MMM yyyy', 'wb.search.showThumbnails':true };

  private lastSavedPreferences: { [key: string]: any; } = {};
  apiUrl: string = '';
  apiKey: string = '';
  preferencesEndpoint = 'core/preferences';

  private preferencesControls: PreferenceItem[] = [];


  constructor(private http: HttpClient, @Inject('CONFIG_SETTINGS') config: any, @Inject(OKTA_AUTH) private auth: OktaAuth) {
    super(PreferencesService);
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];

    this.load();
  }

  public load() {
    const token = this.getToken();

    if (token != undefined) {
      // Retrieve from service
      this.http.get<Preferences>(this.apiUrl + this.preferencesEndpoint, this.getHttpOptions(token))
        .toPromise()
        .then((prefs) => {
          if (prefs != null) {
            this.currentPreferences = prefs.preferences;
          }
          
        });
    }
   
  }

  public registerControls(items: PreferenceItem[]) {
    this.preferencesControls = items;
  }

  private save() {

    this.auth.getUser()
      .then((user) => {
        const token = this.getToken();

        if (this.preferencesObject == null) {
          this.preferencesObject = {
            id: uuidv4(), email: user?.email, preferences: {}
          };
        }

        if (token != undefined) {
          this.preferencesObject.preferences = this.currentPreferences;

          //Persist to service
          this.http.post(this.apiUrl + this.preferencesEndpoint, this.preferencesObject, this.getHttpOptions(token)).subscribe(
            err => console.log(err));
        }
      });

  }

  public getPreferences(): { [key: string]: any } {
    if (Object.keys(this.currentPreferences).length === 0) {
      //this.load();
    }
    return this.currentPreferences;
  }

  public savePreference(key: string, val: any) {
    this.currentPreferences[key] = val;
    this.save();
  }

  private getToken(): string | undefined {
    return this.auth.getAccessToken();
  }

  private getHttpOptions(token: string): object {

    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'Ocp-Apim-Subscription-Key': this.apiKey
      })
    };

  }

  public getPreferencesControlList(): PreferenceItem[] {
    return this.preferencesControls;
  }

}

interface Preferences {
  id: string;
  email: string | undefined;
  preferences: { [key: string]: any; };
}
